import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ContractMinDaysStatus } from '../../models';

export const ContractMinDaysStatusActions = createActionGroup({
    source: 'Margin Calculator - Contract Min Dates Status',
    events: {
        loadStatus: props<{
            candidateId: number;
            facilityId: number;
            /** parameter is optional - use 0 if not defined */
            billingRate: number;
            startDate: Date;
            endDate: Date;
        }>(),
        loadStatusSuccess: props<{ status: ContractMinDaysStatus }>(),
        loadStatusFail: props<{ message: string }>(),
        addStatusToCache: props<{
            cache: Array<{ key: string; value: ContractMinDaysStatus }>;
            status: ContractMinDaysStatus;
        }>(),
        clearStatus: emptyProps()
    }
});
